<template>
  <k-button v-if="sessionReplayStore.isRecording" class="s-sessionReplayPanel ml-3 px-3" variant="outlined" color="error" prepend-icon="far fa-stop-circle" :aria-label="$t('sessionReplay.stop')" :disabled="sessionReplayStore.isStopping" @click="stopRecording"
    >{{ $t("sessionReplay.stop") }}
    <span class="s-sessionReplayPanel__elapsed ml-2" aria-hidden="true">{{ elapsedTime }}</span>
  </k-button>
</template>

<script setup lang="ts">
import { computed } from "vue"
import { useI18n } from "vue-i18n"
import { useSessionReplayStore } from "@/store/sessionReplay"
import { useSnackbarsStore } from "@/store/snackbars"

const sessionReplayStore = useSessionReplayStore()
const snackbarsStore = useSnackbarsStore()
const { t } = useI18n()

const elapsedTime = computed(() => {
  const seconds = sessionReplayStore.elapsedSeconds
  const minutes = Math.floor(seconds / 60)
  const parts = [minutes % 60, seconds % 60].map((part) => String(part).padStart(2, "0"))
  if (minutes >= 60) {
    parts.unshift(String(Math.floor(minutes / 60)).padStart(2, "0"))
  }
  return parts.join(":")
})

async function stopRecording() {
  await sessionReplayStore.stop()
  if (sessionReplayStore.error) {
    snackbarsStore.error(t(`sessionReplay.${sessionReplayStore.error}`))
  }
}
</script>

<style scoped lang="scss">
.s-sessionReplayPanel:focus-visible {
  outline: 2px solid currentColor;
  outline-offset: 2px;
}
.s-sessionReplayPanel__elapsed {
  font-variant-numeric: tabular-nums;
}
</style>
